import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "./Reveal";

const LEVELS = [
    {
        code: "Dossiê · Nível 01",
        name: "Esboço Investigativo",
        desc: "Raio-X inicial baseado em dados públicos. Ideal para identificar o sintoma principal e o volume financeiro do vazamento.",
        scope: [
            "Diagnóstico inicial de canais",
            "Mapeamento de incoerências de oferta",
            "Relatório de evidências primárias",
        ],
    },
    {
        code: "Dossiê · Nível 02",
        name: "Investigação Focada",
        desc: "Análise cirúrgica de um gargalo específico (ex: queda de conversão ou alto churn). Entrega causas-raiz e ações diretas.",
        scope: [
            "Auditoria do processo de vendas",
            "Análise de atendimento de leads",
            "Plano de estancamento rápido",
        ],
    },
    {
        code: "Dossiê · Nível 03",
        name: "Diagnóstico Completo",
        desc: "Varredura 360º das camadas Comercial, Econômica e de Recuperação. Inclui cálculo de oportunidade e plano de ação priorizado.",
        scope: [
            "Varredura completa das 4 Camadas",
            "Identificação de custos invisíveis",
            "Dossiê tático de execução",
        ],
    },
    {
        code: "Dossiê · Nível 04",
        name: "Investigação Avançada / Corporativa",
        desc: "Para negócios complexos ou multiunidades. Inclui a Camada 4 (Reconstrução), análise de identidade, processos e governança.",
        scope: [
            "Análise de operações multiunidades",
            "Acompanhamento tático de implementação",
            "Blindagem contínua de margem",
        ],
    },
];

export default function Levels() {
    return (
        <section
            id="niveis"
            className="relative border-t border-gold-faint bg-[#141414] px-6 py-28 lg:px-10 lg:py-36"
            data-testid="levels-section"
        >
            <div className="mx-auto max-w-7xl">
                <div className="max-w-2xl">
                    <Reveal>
                        <Eyebrow>Exhibit D — Escala de Profundidade</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-7 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-5xl">
                            Profundidade da{" "}
                            <em className="italic text-gold">Investigação</em>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.14}>
                        <p className="mt-7 text-lg font-light leading-relaxed text-[#e6e6e6]">
                            Cada negócio possui uma complexidade única. Os níveis abaixo são
                            estruturados sob medida após a análise do seu Esboço Inicial.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
                    {LEVELS.map((lv, i) => (
                        <Reveal key={lv.code} delay={i * 0.07} className="h-full">
                            <motion.article
                                whileHover={{ y: -6 }}
                                className="flex h-full flex-col border border-line bg-[#0a0a0a] p-8 transition-colors duration-300 hover:border-gold-line"
                                data-testid={`level-card-${i + 1}`}
                            >
                                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                                    {lv.code}
                                </span>
                                <h3 className="mt-6 min-h-[3.5rem] font-serif text-xl leading-snug text-white">
                                    {lv.name}
                                </h3>
                                <p className="mt-4 text-sm leading-relaxed text-[#9a9a9a]">
                                    {lv.desc}
                                </p>
                                <ul className="mt-6 space-y-2.5 border-t border-white/5 pt-6">
                                    {lv.scope.map((s) => (
                                        <li
                                            key={s}
                                            className="flex items-start gap-2.5 font-mono text-[11px] leading-relaxed text-[#888888]"
                                        >
                                            <span className="mt-[5px] h-1 w-1 shrink-0 rotate-45 bg-gold" />
                                            {s}
                                        </li>
                                    ))}
                                </ul>
                            </motion.article>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <p
                        className="mx-auto mt-16 max-w-2xl text-center font-serif text-lg italic leading-relaxed text-[#e6e6e6]"
                        data-testid="levels-note"
                    >
                        “A definição do nível ideal para o seu momento é feita em conjunto com
                        o investigador após a entrega do Esboço Inicial.”
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
